import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IGenericFormLoader } from '../../interfaces/form-label';

@Component({
  selector: 'cargoes-inspection-finding',
  templateUrl: './inspection-finding.component.html',
  styles: [],
})
export class InspectionFindingComponent implements OnInit, IGenericFormLoader {

  @Input() defaultFormData: any;
  @Output() submitedFormData = new EventEmitter<any>();
  actions: any [] = [];
  inspectionFindingGroup!: FormGroup;
  load = false;
  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    if(typeof this.defaultFormData === 'object' ){
      this.onLoad(this.defaultFormData);
      this.load = true;
    }
  }


  onLoad(data: any) {
    this.inspectionFindingGroup = this.formBuilder.group({
      selectedAction: ['', [Validators.required]],
      comments: [null]
    });
    let keys = Object.keys(data.rdmData);
    keys.forEach((key) => {
      this.actions = data.rdmData[key];
    });
  }


  onSubmit() {
    let formData = {
      "variables": {
        "selectedAction": { "value": this.inspectionFindingGroup.value.selectedAction },
        "comments": { "value": this.inspectionFindingGroup.value.comments }
      }
    };
    this.submitedFormData.emit(formData);
  }
}
